import { AllProducts } from './Products';

const isBusinessOrder = (selectedAddress) => {
  const isBusiness = AllProducts?.some(({ productCode, internal }) => {
    const businessProducts =
      selectedAddress?.cityFibreProducts?.some(({ productName }) =>
        productCode.includes(productName),
      ) ??
      selectedAddress?.litFibreProducts?.some(({ productName }) =>
        productCode.includes(productName),
      );
    return businessProducts && internal;
  });
  return isBusiness;
};
export default isBusinessOrder;
